import script from "./remarks.vue?vue&type=script&lang=ts&setup=true"
export * from "./remarks.vue?vue&type=script&lang=ts&setup=true"

import "./remarks.vue?vue&type=style&index=0&id=7b0f2e48&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b0f2e48"]])

export default __exports__